import store from "@/store";

const routes = [
  {
    path: "/accounting/itemcosting/:id",
    name: "acctitemcosting",
    component: () => import("@/views/main/modules/Accounting/ItemCosting/ItemCostingGroupComponent"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Item Costing",
    },
  },
];

export default routes;
